import { render, staticRenderFns } from "./IngredientCombobox.vue?vue&type=template&id=17b18da6&scoped=true&"
import script from "./IngredientCombobox.vue?vue&type=script&lang=js&"
export * from "./IngredientCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b18da6",
  null
  
)

export default component.exports